import axios from 'axios';
import { getAuthToken } from '@/auth/authCredentials';

const API_HOST=process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN : '';
const API_URL='/api';
const BASE_URL=API_HOST+API_URL;


const instance = axios.create({
  baseURL: BASE_URL,
  validateStatus: function (status) {
    // 400 이상의 에러만 catch 블럭에서 처리하고, 그 외에는 then 블럭에처 처리한다.
    return status  < 400;
  }
  // timeout: 1000,
});

export function getAxiosInstance() {
  return instance;
}

export const BaseApi = {
  get,
  post,
  put,
  patch,
  delete: _delete
};

function get(url, config){
  const reqConfig = addAuthTokenToHeaders(config);
  return instance.get(url, reqConfig);
}

function post(url, data, config){
  const reqConfig = addAuthTokenToHeaders(config);
  return instance.post(url, data, reqConfig);
}

function put(url, data, config){
  const reqConfig = addAuthTokenToHeaders(config);
  return instance.put(url, data, reqConfig);
}

function patch(url, data, config){
  const reqConfig = addAuthTokenToHeaders(config);
  return instance.patch(url, data, reqConfig);
}

function _delete(url, config){
  const reqConfig = addAuthTokenToHeaders(config);
  return instance.delete(url, reqConfig);
}

function addAuthTokenToHeaders(config){
  const reqConfig = config || {};
  const token = getAuthToken();
  if (token) {
    const authorization = `Bearer ${token}`;
    if (reqConfig.headers) {
      reqConfig.headers.Authorization = authorization;
    } else {
      reqConfig.headers = { Authorization: authorization };
    }
  }

  return reqConfig;
}
export default BaseApi;
